import httpClient from './http-client';
import mockProfileService from './profile.service.mock';

let profileService;

if (process.env.NODE_ENV === 'development') {
  profileService = mockProfileService;
} else {
  profileService = {
    getCurrentUser() {
      return httpClient.get('/profile');
    },

    updateCurrentUser(profile) {
      return httpClient.put('/profile', profile);
    },

    getAdditionalAccessRequest(id) {
      return httpClient.get(`/profile/additionalAccess/${id}`);
    },

    updateAdditionalAccessRequest(request) {
      return httpClient.put('/profile/additionalAccess', request);
    },

    // type, orderId
    getAdditionalReasonDocument(params) {
      return httpClient.get('/profile/additionalReasonDocument', { params });
    },

    submitAdditionalAccessRequest(request) {
      return httpClient.post(`/profile/additionalAccessSubmit/${request.orderId}`);
    },

    initAdditionalAccessRequest() {
      return httpClient.post('/profile/additionalAccessInit');
    },

    deleteAdditionalAccessRequest(id) {
      return httpClient.delete(`/profile/additionalAccessDelete/${id}`);
    },

    attachAdditionalReasonDocument(orderId, file) {
      const body = new FormData();
      body.append('file', file);
      const params = {
        orderId,
      };
      return httpClient.post('/profile/additionalReasonDocument', body, { params });
    },

    deleteAdditionalReasonDocument(orderId, attachmentId) {
      const params = {
        orderId,
        attachmentId,
      };
      return httpClient.delete('/profile/additionalReasonDocument', { params });
    },

    getAdditionalRepresentationRequest(id) {
      return httpClient.get(`/profile/additionalRepresentation/${id}`);
    },

    updateAdditionalRepresentationRequest(request) {
      return httpClient.put('/profile/additionalRepresentation', request);
    },

    deleteAdditionalRepresentationRequest(request) {
      return httpClient.delete(`/profile/additionalRepresentationDelete/${request.orderId}`);
    },

    submitAdditionalRepresentationRequest(request) {
      return httpClient.post(`/profile/additionalRepresentationSubmit/${request.orderId}`);
    },

    initAdditionalRepresentationRequest() {
      return httpClient.post('/profile/additionalRepresentationInit');
    },

    // params: firstname, lastname, personCode, qualificationType, qualificationNumber, myInstitution, page, pageSize
    getList(params) {
      return httpClient.get('/profile/profileList', { params });
    },

    // params: typeCode, regNumber, page, pageSize
    getCurrentUserQualificationList(params) {
      return httpClient.get('/profile/qualification', { params });
    },

    getCurrentUserAccessRights(params) {
      return httpClient.get('/profile/access', { params });
    },

    getCurrentUserReport() {
      return httpClient.get('/profile/report');
    },

    getCurrentUserSettings() {
      return httpClient.get('/profile/setting');
    },

    updateCurrentUserSettings(settings) {
      return httpClient.put('/profile/setting', settings);
    },

    getCurrentUserIntegrationData() {
      return httpClient.get('/profile/update');
    },

    initCurrentUserIntegrationDataUpdate() {
      return httpClient.post('/profile/update');
    },

    initCurrentUserQualificationsDataUpdate() {
      return httpClient.post('/profile/update/lis');
    },

    initCurrentUserPasswordChange() {
      return httpClient.post('/profile/changePassword');
    },

    // payload: { token, newPassword, repeatPassword }
    changePassword(payload) {
      return httpClient.post('/pub/resetPassword', payload);
    },

    // params: type, dateFrom, dateTo, orderBy
    getCurrentUserRequests(params) {
      return httpClient.get('/profile/request', { params });
    },

    updateBnkRequest(request) {
      return httpClient.put('/profile/bnkRequest', request);
    },

    getBnkRequest(id) {
      return httpClient.get(`/profile/bnkRequest/${id}`);
    },

    getBnkRequestAttachments(params) {
      return httpClient.get('/profile/bnkRequestAttachment', { params });
    },

    uploadBnkRequestAttachment(orderId, file) {
      const body = new FormData();
      body.append('file', file);
      const params = {
        orderId,
      };
      return httpClient.post('/profile/bnkRequestAttachment', body, { params });
    },

    // { orderId, attachmentId }
    deleteBnkRequestAttachment(params) {
      return httpClient.delete('/profile/bnkRequestAttachment', { params });
    },

    deleteBnkRequest(id) {
      return httpClient.delete(`/profile/bnkRequestDelete/${id}`);
    },

    initBnkRequest() {
      return httpClient.post('/profile/bnkRequestInit');
    },

    submitBnkRequest(id) {
      return httpClient.post(`/profile/bnkRequestSubmit/${id}`);
    },

    getCurrentUserBnkSubscriptions() {
      return httpClient.get('/profile/bnk');
    },
    
    importProfile(request){
        return httpClient.post(`/profile/importProfile`,request);
    },

    getBnkSubscription(id) {
      return httpClient.get(`/profile/bnk/${id}`);
    },

    // { bnkId, attachmentId }
    getBnkSubscriptionAttachment(params) {
      return httpClient.get('/profile/bnk/attachment', { params });
    },

    revokeBnkSubscription(id) {
      return httpClient.post(`/profile/bnk/revoke/${id}`);
    },
  };
}

export default profileService;
